import React, { useContext } from 'react';
import styles from './PassportDocumentCenterModal.module.scss';
import { CheckboxSelections, Tag } from '@ds';
import { TagVariant } from '@ds/elements/Tag/Tag.types';
import { getFormattedDate, UserDateFormat } from 'src/utils/formatters/formatDate';
import DocumentsGrid from '../DocumentsGrid/DocumentsGrid';
import { BeneDocAdditionalContext } from 'src/shared/providers/DocumentUploadContextProvider';
import { PassportInfo } from 'src/shared/types/Case';
import moment from 'moment';
import { FallbackPlaceholderText } from 'src/utils/constants/common';

interface CompletePassportProps {
  passportInfo: PassportInfo;
  allCasePassports?: boolean;
  onItemToggle: (isSelected: boolean) => void;
  isSelected: boolean;
}

const PassportItem: React.FC<CompletePassportProps> = ({
  passportInfo,
  allCasePassports = false,
  onItemToggle,
  isSelected,
}) => {
  const { beneMembers } = useContext(BeneDocAdditionalContext);
  const expirationMessage = passportInfo?.passportExpirationDate
    ? `EXPIRES: ${getFormattedDate(passportInfo.passportExpirationDate.toString(), UserDateFormat.get())}`
    : FallbackPlaceholderText.NotAvailable;

  const togglePassportSelected = () => {
    onItemToggle(!isSelected);
  };

  const isExpired = passportInfo?.passportExpirationDate
    ? moment().isAfter(moment(passportInfo.passportExpirationDate))
    : false;

  const currentBeneMember = beneMembers?.find((member) => member?.id === passportInfo?.issuedTo);
  const createPassportName = () => {
    if (allCasePassports) {
      return `Passport number: [${currentBeneMember?.fullName}] #${passportInfo?.passportNumber}`;
    } else {
      return `Passport number: #${passportInfo?.passportNumber}`;
    }
  };

  return (
    <div className={`${styles['passport-item']} p-2`}>
      <div className={`${styles['header']} flex flex-row gap-4 px-3 py-2 mb-2`}>
        <div className={`flex flex-col w-full gap-2`}>
          <div
            className={`flex flex-col sm:flex-row gap-2 sm:gap-4 items-start sm:items-center  ${
              isExpired ? 'sm:justify-between' : 'sm:justify-start'
            }`}
          >
            <p>{createPassportName()}</p>
            {isExpired ? <Tag variant={TagVariant.Error}>Expired</Tag> : <Tag>{expirationMessage}</Tag>}
          </div>
          <div className={`${styles['file-count']} flex flex-row gap-2 my-1`}>
            <span> {currentBeneMember?.fullName}:</span>
            {passportInfo?.documents?.length && (
              <span>
                {passportInfo.documents?.length} document{passportInfo.documents?.length !== 1 && 's'}
              </span>
            )}
          </div>
        </div>
        <div className={`self-start mt-[2px]`}>
          <CheckboxSelections
            title=""
            options={[{ label: '', checked: isSelected, disabled: false }]}
            onCheckboxChanged={togglePassportSelected}
          />
        </div>
      </div>

      <DocumentsGrid documents={passportInfo.documents || []} isPassport isReadonly showMenu={false} />
    </div>
  );
};

export default PassportItem;
